/*  eslint-disable no-useless-computed-key, react-hooks/exhaustive-deps, no-useless-escape  */
import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { companyValidation } from '../_validation'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { FileUpload } from 'primereact/fileupload'
import NumberFormat from 'react-number-format'
import { useParams } from 'react-router'
import { status, booleanList, growth } from '../_common/utils'
import back from '../assets/images/back.svg'
import { fileUploadConstants } from '../_constants'
import { userActions } from '../_actions'
import SubBrandComponent from '../components/SubBrandComponent'

function AddCompanyComponent({ masterList, addCompany, lookupIndustry, singleEntry, logo, getCompanyById, updateSubBrand, subBrandData, bulkUpdate, bulkUpdatesubBrand, deleteCompany }) {
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const history = useHistory()
  const { id } = useParams()
  const { industryId, sectorId } = useParams()
  const [subBrandLogo, setSubBrandLogo] = useState(null)
  const [subBrandLogoPath, setSubBrandLogoPath] = useState(null)
  const fileInput = useRef(null)
  const [industryList, setIndustry] = useState([])
  const [company, setCompany] = useState({})
  const [subBrands, setSubBrands] = useState([])

  useEffect(() => {
    setCompany({
      'name': singleEntry != null ? singleEntry.name : '',
      'ticker': singleEntry != null ? singleEntry.ticker : '',
      'grade': singleEntry != null ? singleEntry.grade : '',
      'marketCapitalization': singleEntry != null ? singleEntry.marketCapitalization : 0,
      'exchangeCountry': singleEntry != null ? singleEntry.exchangeCountry : '',
      'earningsYeild': singleEntry != null ? singleEntry.earningsYeild : '',
      'barriers': singleEntry != null ? singleEntry.barriers : '',
      'grades': singleEntry != null ? singleEntry.grades : '',
      'financialStrength': singleEntry != null ? singleEntry.financialStrength : '',
      'momentum': singleEntry != null ? singleEntry.momentum : '',
      'underValued': singleEntry != null ? singleEntry.underValued : '',
      'growthType': singleEntry != null ? singleEntry.growthType : '',
      'topNewsBuy': singleEntry != null ? singleEntry.topNewsBuy : '',
      'dividendLeader': singleEntry != null ? singleEntry.dividendLeader : '',
      'sociallyResponsible': singleEntry != null ? singleEntry.sociallyResponsible : '',
      'watchlist': singleEntry != null ? singleEntry.watchlist : '',
      'intersection': singleEntry != null ? singleEntry.intersection : '',
      'createdBy': userActions.getCurrentUser(),
      'encodedImageString': singleEntry?.encodedImageString ? singleEntry.encodedImageString : '',
      sectorId: singleEntry != null ? singleEntry?.sector?.sectorId : (sectorId ? Number(sectorId) : -1),
      exchangeId: singleEntry?.exchange ? singleEntry.exchange.exchangeId : -1,
      industryId: singleEntry?.industry ? singleEntry.industry.industryId : (industryId ? Number(industryId) : -1),
      parentCompanyId: -1,
      logoPath: singleEntry != null ? singleEntry?.logoPath : '',
      status: singleEntry != null ? singleEntry?.active : true,
      active: singleEntry != null ? singleEntry?.active : true,
    })
    setSubBrands(singleEntry?.subBrandsCompany ? singleEntry.subBrandsCompany : [])
    if (id && singleEntry && singleEntry.sector) {
      bindIndustry(singleEntry.sector.sectorId)
    }
  }, [singleEntry])

  useEffect(() => {
    if (id) {
      getCompanyById(id)
    }
  }, [id])
  useEffect(() => {
    if (subBrandData) {
      setSubBrands(subBrandData)
    }
  }, [subBrandData])
  useEffect(() => {
    if (id && singleEntry && singleEntry.sector) {
      bindIndustry(singleEntry.sector.sectorId)
    } else {
      if (sectorId && industryId) {
        bindIndustry(Number(sectorId))
      }
    }
  }, [masterList])
  const saveSubBrand = () => {
    let companyArray = []
    companyArray = subBrands.filter(f => f.isUpdated === true)
    if (companyArray && companyArray.length > 0) {
      bulkUpdatesubBrand(companyArray)
    }
  }
  const saveCompany = (e) => {
    setErrors(companyValidation.mandatory(company, 1))
    e.preventDefault()
    if (e)
      e.preventDefault()

    if (company.name !== '' && company.sectorId > 0 && company.industryId > 0) {
      if (!isSubmitting) {
        if (id)
          saveSubBrand()
        setIsSubmitting(true)
        company.ticker = company?.ticker?.toUpperCase()
        if (company.sectorId > 0)
          company.sector = masterList.sector.filter(f => f.sectorId === company.sectorId)[0]
        if (company.exchangeId > 0)
          company.exchange = masterList.exchange.filter(f => f.exchangeId === company.exchangeId)[0]
        if (company.exchangeId === -1)
          company.exchangeId = null
        if (company.industryId > 0)
          company.industry = masterList.industry.filter(f => f.industryId === company.industryId)[0]
        company.subBrands = subBrands
        if (id) {
          let companyArray = []
          company.isUpdated = true;
          company.companyId = id;
          company.updatedBy = userActions.getCurrentUser();
          companyArray.push(company)
          bulkUpdate(companyArray)
        } else {
          addCompany(company)
        }
      }
    }

  }

  function onChange(e) {
    const { name, value } = e.target
    if (name === 'ticker')
      setCompany(company => ({ ...company, [name]: value ? value.toUpperCase() : value }))
    else if (name === 'sectorId') {
      bindIndustry(value)
      setCompany(company => ({ ...company, [name]: value }))
    }
    else if (name === 'status') {
      if (value === 'Active') {
        setCompany(company => ({ ...company, ['active']: true, [name]: value }))
      } else {
        setCompany(company => ({ ...company, ['active']: false, [name]: value }))
      }
    }
    else if (name === 'marketCapitalization') {
      setCompany(company => ({ ...company, [name]: value.replace(/\,/g, '') }))
    }
    else {
      setCompany(company => ({ ...company, [name]: value }))
    }
  }
  const bindIndustry = (value) => {
    let dataList = []
    dataList = masterList.industry.map((i) => {
      if (i.sector && i.sector.sectorId === value) {
        return i
      }
      return null
    })
    const tempRows = [...dataList]
    dataList = tempRows.filter(f => f != null)
    setIndustry(dataList)
  }
  function fileNames() {
    const { current } = fileInput
    if (current && current.files.length > 0) {
      let messages = []
      for (const file of current.files) {
        messages = messages.concat(<p key={file.name}>{file.name}</p>)

      }
      return messages
    }
    return null
  }
  const imageOnChange = (event) => {
    if (event && event.target && event.target.value && event.target.value !== '' && event.target.value.trim().length > 0) {
      let target = event.target.value;
      setCompany(company => ({ ...company, ['logoPath']: target, ['encodedImageString']: target.includes('data:image/jpeg;base64,') ? target.replace('data:image/jpeg;base64,', '') : null }))
    }
  }
  const onUpload = (event) => {
    const messages = []
    const result = JSON.parse(event.xhr.response)
    for (const file of event.files) {
      messages.push(file.name)
      setCompany(company => ({ ...company, ['logoPath']: file.name, ['encodedImageString']: result.encodedImageString }))
    }
    return messages
  }
  const onUploadSubBrand = (event) => {
    const result = JSON.parse(event.xhr.response)
    for (const file of event.files) {
      setSubBrandLogo(file.name)
      setSubBrandLogoPath(result.encodedImageString)
    }
  }
  const [brandText, setBrandText] = useState('')
  const subBrandTextOnChange = (event) => {
    if (event.target.value !== '' && event.target.value.trim().length > 0) {
      setBrandText(event.target.value)
    }
  }
  const subBrandAddChange = () => {
    if ((brandText !== '' && brandText?.trim().length > 0) && !subBrands?.includes(brandText)) {
      const subBrand = {}
      subBrand.name = brandText
      subBrand.logoPath = subBrandLogo
      subBrand.encodedImageString = subBrandLogoPath
      if (id)
        subBrand.parentCompanyId = Number(id)
      subBrand.isUpdated = true
      subBrand.marketCapitalization = 0
      subBrand.id = null
      subBrand.createdBy = userActions.getCurrentUser()
      //   subBrands.push(subBrand)
      setBrandText('')
      setSubBrandLogo(null)
      setSubBrandLogoPath(null)
      setSubBrands([...subBrands, subBrand])
    }
    document.getElementById('subBrands').value = ''
  }
  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addCompany">
          <div className="p-grid">
            <div className="p-col-12 titleSec">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
              <h4 className="display_1 m-b-0">{id ? 'Edit' : 'Add'} Company</h4>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Company Name <sup className="inputHolder--required">*</sup></label>
                <InputText name="name" className="inputHolder--inputBox" value={company.name ? company.name : ''} onChange={onChange} placeholder="Company Name" maxLength={256} />
                {errors.name && (
                  <p className='space-danger'>{errors.name}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Ticker </label>
                <InputText name="ticker" className="inputHolder--inputBox" value={company.ticker ? company.ticker : ''} onChange={onChange} placeholder="Ticker" maxLength={15} />
                {errors.ticker && (
                  <p className='space-danger'>{errors.ticker}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Market Capitalization (USD)</label>
                <NumberFormat name="marketCapitalization" value={company.marketCapitalization} thousandSeparator={true} onChange={onChange} placeholder="Market Capitalization" className="inputHolder--inputBox" maxLength={50} />
                {errors.marketCapitalization && (
                  <p className='space-danger'>{errors.marketCapitalization}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Stock Sector <sup className="inputHolder--required">*</sup> </label>
                <Dropdown name="sectorId" dataKey="sectorId" optionLabel="name" optionValue="sectorId" options={masterList.sector} disabled={sectorId && Number(sectorId) > 0 ? true : false} className="inputHolder--dropdownBox" placeholder="[Select Stock Sector]" value={company.sectorId} onChange={onChange} />
                {errors.sectorName && (
                  <p className='space-danger'>{errors.sectorName}</p>
                )}
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Sub Industry <sup className="inputHolder--required">*</sup> </label>
                <Dropdown name="industryId" dataKey="industryId" optionLabel="name" optionValue="industryId" options={industryList} className="inputHolder--dropdownBox" placeholder="[Select Sub Industry]" disabled={industryId && Number(industryId) > 0 ? true : false} value={company.industryId} onChange={onChange} /></span>
              {errors.industryName && (
                <p className='space-danger'>{errors.industryName}</p>
              )}
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Exchange</label>
                <Dropdown name="exchangeId" dataKey="exchangeId" options={masterList.exchange} optionLabel="name" optionValue="exchangeId" className="inputHolder--dropdownBox" placeholder="[Select Exchange]" value={company.exchangeId} onChange={onChange} />
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Status </label>
                <Dropdown name="status" options={status} className="inputHolder--dropdownBox" placeholder="[Select Status]" value={company.status} onChange={onChange} />
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Exchange Country</label>
                <InputText name="exchangeCountry" className="inputHolder--inputBox" value={company.exchangeCountry ? company.exchangeCountry : ''} onChange={onChange} placeholder="Exchange Country" maxLength={256} />
              </span>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Earnings Yield</label>
                <InputText name="earningsYeild" className="inputHolder--inputBox" value={company.earningsYeild ? company.earningsYeild : ''} onChange={onChange} placeholder="Earnings Yield" maxLength={256} />
              </span>
            </div>
            <div className="p-col-12 subBrandCon">
              <span className="inputHolder flexStartRow">
                <div className="p-col-6">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Company Logo</label>
                    <FileUpload name="file" onUpload={onUpload} accept="image/*" url={fileUploadConstants.FILE_UPLOAD_URL} maxFileSize={1000000} auto={true} multiple={false} />
                  </span>
                </div>
                <div className="p-col-6 subBrandCustom flexcolumn">
                  <InputText id="paste" style={{ marginTop: '30px' }} className="inputHolder--inputBox" onKeyPress={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      imageOnChange(e)
                    }
                  }} placeholder="Paste image here" />
                </div>
              </span>
              {company.logoPath &&
                  ((company.logoPath.includes('https:')||company.logoPath.includes('http:'))? <img alt="Logo" id="imgLogo" src={`${company.logoPath}`} style={{ width: '80px', height: '80px' }}></img> : <img alt="Logo" id="imgLogo" src={`data:image/jpeg;base64,${company.encodedImageString}`} style={{ width: '80px', height: '80px' }}></img> )
              }
              {fileNames()}

            </div>
            <div className="w-100 subBrandCon">
              <span className="inputHolder flexStartRow">
                <div className="p-col-6">
                  <div className="inputHolder--label m-b-10">Sub Brand Logo</div>
                  <div className="flexStartRow">
                    <FileUpload name="file" onUpload={onUploadSubBrand} accept="image/*" url={fileUploadConstants.FILE_UPLOAD_URL} maxFileSize={1000000} auto={true} multiple={false} />
                    {subBrandLogo && (subBrandLogoPath ? <img alt="Subbrand Logo" className="m-l-10" id="subImgLogo" src={`data:image/jpeg;base64,${subBrandLogoPath}`} style={{ width: '60px', height: '32px' }}></img>
                      : <img alt="Subbrand Logo" className="m-l-10" id="subImgLogo" src={`${subBrandLogo}`} style={{ width: '60px', height: '32px' }}></img>)}
                  </div>
                </div>
                <div className="p-col-6 subBrandCustom flexcolumn">
                  <div className="inputHolder--label m-b-10">Sub Brand </div>
                  <div className="flexCenter">
                    <InputText id="subBrands" className="inputHolder--inputBox" onKeyPress={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        subBrandAddChange()
                      }
                    }} onChange={(event) => subBrandTextOnChange(event)} placeholder="Sub Brand" maxLength={256} />
                    <Button type="button" icon="pi pi-plus" onClick={() => subBrandAddChange()} className="addBtnCustom" title="Add" />
                  </div>
                </div>
              </span>
            </div>
            <SubBrandComponent
              brandList={subBrands}
              isAddCompany={true}
              updateSubBrand={updateSubBrand}
              deleteCompany={deleteCompany}
            />

            <div className="p-col-12 titleSec">
              <h4 className="display_1 m-b-0">Map Key</h4>
            </div>
            <div className="p-col-12">
              <div className="highlightsSec">
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Barriers </label>
                    <Dropdown name="barriers" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.barriers} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Financial Strength </label>
                    <Dropdown name="financialStrength" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.financialStrength} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Momentum </label>
                    <Dropdown name="momentum" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.momentum} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Growth Type </label>
                    <Dropdown name="growthType" options={growth} className="inputHolder--dropdownBox" placeholder="N/A" value={company.growthType} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Top New Buys  </label>
                    <Dropdown name="topNewsBuy" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.topNewsBuy} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Dividend Leader </label>
                    <Dropdown name="dividendLeader" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.dividendLeader} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Socially Responsible </label>
                    <Dropdown name="sociallyResponsible" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.sociallyResponsible} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Watch List </label>
                    <Dropdown name="watchlist" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.watchlist} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Intersection </label>
                    <Dropdown name="intersection" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.intersection} onChange={onChange} />
                  </span>
                </div>
                <div className="p-col-4">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Undervalued </label>
                    <Dropdown name="underValued" options={booleanList} className="inputHolder--dropdownBox" placeholder="N/A" value={company.underValued} onChange={onChange} />
                  </span>
                </div>
              </div>
            </div>
            <div className="p-col-12 m-t-10">
              <Button label="Save" onClick={(event) => saveCompany(event)} className="p-button-raised p-button-rounded inputHolder--formBtn" />
            </div>
          </div>
          {/* </Form> */}
        </Card>
      </div>
    </div>
  )
}
AddCompanyComponent.propTypes = {
  masterList: PropTypes.object,
  addCompany: PropTypes.func,
  getCompanyById: PropTypes.func,
  logoUpload: PropTypes.func,
  lookupIndustry: PropTypes.func,
  singleEntry: PropTypes.object,
  logo: PropTypes.object,
  updateSubBrand: PropTypes.func,
}
export default AddCompanyComponent
